import { useMutation } from '@tanstack/react-query';

import type { User } from '../../../types';

import { userService } from '../../../Domain/Users/Services';

type UnblockUserData = Pick<User, 'userId'>;

const mutationFn = (data: UnblockUserData) => {
  return userService.unblockUser(data?.userId);
};

export const useUserUnblockMutation = () => {
  return useMutation<unknown, unknown, UnblockUserData>(mutationFn);
};
